import { observable, action, computed } from 'mobx'
import _ from 'lodash';
import { CASINO_CATEGORY_TYPE, defaultProviders } from '../common/Foundation'
import CommonUtil from '../common/Utils'
import Constants from '../common/Constants';
import Utils from "../common/Utils";
const { NEW } = CASINO_CATEGORY_TYPE;

export default class CasinoStore {

  @observable playtechGamesData = {};

  listOfSubCategoryForNew = [];
  defaultLimitSearchingChars = 80;
  defaultLoadMoreItems = 25;

  defaultNewCategory = {
    id: -1,
    categoryName: 'New',
    isDefault: true,
    orderBy: 2,
  };

  defaultCategory = {
    '0': {
      mainCategory: {
        id: 0,
        categoryName: 'All Games',
        isDefault: true,
        orderBy: 0,
      },
      subCategory: null
    }
  };

  defaultSubCategory = {
    id: 0,
    categoryName: 'All',
    isDefault: true,
    orderBy: 0,
  };

  defaultCasinoFilter = {
    categoryId: '',
    gameName: '',
    provider: '',
    beginIndex: 0,
    moreItems: this.defaultLoadMoreItems,
    isNewGame: "",
    orderBy: 'gameName,provider',
    gameType: '',
    providerId: defaultProviders[0]['providerId'],
    providerName: defaultProviders[0]['providerName'],
    providerList: []
  };

  @observable isSearchingGames = false;
  @observable isFetchingGames = false;
  @observable isLoadMoreGames = true;
  @observable isServerError = false;
  @observable casinoSlider = [];
  @observable categories = {};
  @observable selectedCategory = {};
  @observable casinoGames = [];
  @observable wallets = [];

  @observable limitSearchingChars = this.defaultLimitSearchingChars;
  @observable numberOfRecordsPerPage = this.defaultLoadMoreItems;
  @observable loadMoreItems = 28;
  @observable casinoFilter = this.defaultCasinoFilter;
  @observable gameflexExpressLibrary = [];
  @observable jackpotList = [];
  @observable casinoProviders = [];
  @observable listCasinoSideBar = [];
  @observable isShowCasinoGameWindow = false;
  @observable isLoadingGame = false;
  @observable isCasinoFavouriteClicked = false;
  @observable gameWindowParamaters = {};
  @observable hasBannerSlider = false;
  @observable selectedProviders = []
  @observable otherCasinoProviders = []
  
  @observable isLiveCasino = undefined;
  @observable selectedMenuItem = "";

  @action updateWallets = (wallets) => {
    this.wallets = wallets;
  }

  @action resetFavoritesCategory = () => {
    this.selectedCategory = this.defaultFavoriteCategory[0];
  }

  @action updateGameflexExpressLibrary = (gameflexExpressLibrary) => {
    this.gameflexExpressLibrary = gameflexExpressLibrary;
  }

  @action updateJackpotList = (jackpotList) => {
    this.jackpotList = jackpotList;
  }


  @action updateJackpots = (key) => {
    const jackpots = _.map(this.jackpotList, (value, index) => {
      if (value.IncrementInterval === key) {
        value.Amount += value.IncrementValue;
      }
      return value;
    });
    this.jackpotList = jackpots;
  }

  @action updateGameWindowParamaters = (gameWindowParamaters) => {
    this.gameWindowParamaters = gameWindowParamaters;
  }

  @action setCasinoFavouriteClicked = (isCasinoFavouriteClicked) => {
    this.isCasinoFavouriteClicked = isCasinoFavouriteClicked;
  }

  @action setLiveCasino = (isLiveCasino) => {
    this.isLiveCasino = isLiveCasino;
  }

  @action setSelectedMenuItem = (item) => {
    this.selectedMenuItem = item;
  }

  @action updateCasinoGameWindow = (flag) => {
    this.isShowCasinoGameWindow = flag;
  }

  @action updateLoadingGame = (flag) => {
    this.isLoadingGame = flag;
  }

  @action updateIsSearchingGames = (isSearchingGames) => {
    this.isSearchingGames = isSearchingGames;
  }

  @action checkServerError = (isServerError) => {
    this.isServerError = isServerError;
  }

  @action updateIsFetchingGames = (isFetchingGames) => {
    this.isFetchingGames = isFetchingGames;
  }

  @action updateIsLoadMoreGames = (isLoadMoreGames) => {
    this.isLoadMoreGames = isLoadMoreGames;
  }

  @action updateMoreItemsFilter = (moreCasinoGames) => {
    this.isLoadMoreGames = true;
    const moreItems = moreCasinoGames > 0 ? moreCasinoGames : this.loadMoreItems;

    let tmp = CommonUtil.convertMobxObjToJsonObj(this.casinoFilter);
    tmp['beginIndex'] = tmp['beginIndex'] + tmp['moreItems'];

    if (moreItems !== tmp['moreItems']) {
      tmp['moreItems'] = moreItems;
    }
    this.numberOfRecordsPerPage += moreItems;
    this.casinoFilter = tmp;
  }

  @action resetCasinoFilter = () => {
    this.isLoadMoreGames = true;
    this.updateCasinoFilter('beginIndex', 0);
    this.numberOfRecordsPerPage = this.defaultLoadMoreItems;
    this.casinoFilter['moreItems'] = this.defaultLoadMoreItems;
  }

  @action updateCasinoSlider = (casinoSlider) => {
    let tmp = CommonUtil.convertMobxObjToJsonObj(this.casinoSlider);
    tmp = casinoSlider;
    this.casinoSlider = tmp;
  }

  @action updateCasinoProviders = (casinoProviders) => {
    this.casinoProviders = casinoProviders
  }

  @action updatelistCasinoSideBar = (list) => {
    this.listCasinoSideBar = list;
  }

  @action updateHasBannerSlider = (value) => {
    this.hasBannerSlider = value;
  }

  /**
   * TODO: After feature sequence all category release
   * 	Remove case hardcode 'All Games' on UI
   * */
  @action updateCategory = (categories, isDefault) => {
    if (!categories) return
    this.updateNewCategoryProcess();
    const orderByCategory = _.orderBy(categories, ['mainCategory.orderBy'])
    const highestSequenceCategoryId = _.get(orderByCategory, [0, 'mainCategory', 'id'], 0)
    const allGameCategoryId = Object.keys(categories).find(key => {
      const allCategoryName = categories[key] && categories[key].mainCategory && categories[key].mainCategory.categoryName &&
        categories[key].mainCategory.categoryName.trim().toLocaleLowerCase()
      return  Utils.isSelectedAllCategory(allCategoryName);
    })
    const isSequenceCasinoEnabled = window.env.casinoSequenceCategoryEnabled && allGameCategoryId
    const selectedCategoryId = highestSequenceCategoryId !== allGameCategoryId ? highestSequenceCategoryId : allGameCategoryId
	// keep selected category when change language
    const selectedCategoryName = !isDefault && this.selectedCategory.mainCategory &&
      this.selectedCategory.mainCategory.categoryName !== 'All Games'
      ? this.selectedCategory.mainCategory.categoryName
      : null
    if (selectedCategoryName) {
      // avoid merge default category if player switch language
      if (isSequenceCasinoEnabled) {
        this.categories = categories;
      } else {
        this.categories = _.merge(CommonUtil.convertMobxObjToJsonObj(this.defaultCategory), categories);
      }
      this.updateCategoryProcess(Object.values(categories).filter(item => item.mainCategory.categoryName === selectedCategoryName)[0]);
    } else if (isSequenceCasinoEnabled) {
      this.categories = categories;
      this.updateCategoryProcess(this.categories[selectedCategoryId]);
    } else {
      this.categories = _.merge(CommonUtil.convertMobxObjToJsonObj(this.defaultCategory), categories);
      this.updateCategoryProcess(this.defaultCategory[0]);
    }
  }

  @action selectMainCategory = (category) => {
    const currentCategory = this.categories[category.id] || {};
    this.resetCasinoFilter();
    this.updateCategoryProcess(currentCategory);
  }

  @action getDefaultCategory = () => {
    return this.defaultCategory;
  }

  @action selectSubCategory = (category) => {
    this.resetCasinoFilter();

    let tmp = CommonUtil.convertMobxObjToJsonObj(this.selectedCategory)
    tmp['subCategory'] = category;
    this.selectedCategory = tmp;
    const subCategoryId = _.get(this.selectedCategory, 'subCategory.id', 0);
    const mainCategoryId = _.get(this.selectedCategory, 'mainCategory.id', 0);
    let categoryId = '';

    if (subCategoryId === -1) {
      categoryId = mainCategoryId;
      this.updateCasinoFilter('isNewGame', true);
    } else if (subCategoryId !== 0) {
      categoryId = subCategoryId;
    } else if (subCategoryId === 0 && mainCategoryId !== 0) {
      categoryId = mainCategoryId;
      this.updateCasinoFilter('isNewGame', '');
    }

    this.updateCasinoFilter('categoryId', categoryId);
  }

  updateNewCategoryProcess = () => {
    const defaultNewCategory = this.defaultNewCategory;
    _.forEach(this.categories, (cat, key) => {
      const mainCategory = cat['mainCategory'];
      const subCategory = cat['subCategory'];

      if (_.includes(this.listOfSubCategoryForNew, mainCategory.categoryName) && !_.isEmpty(subCategory)) {
        cat['subCategory'] = subCategory.addAll(defaultNewCategory);
      }
    });
  }

  updateCategoryProcess = (currentCategory) => {
    if (!currentCategory) return
    const mainCategory = currentCategory['mainCategory'];
    let subCategories = !_.isEmpty(currentCategory['subCategory']) ? _.concat([this.defaultSubCategory], currentCategory['subCategory']) : [];

    if (_.includes(this.listOfSubCategoryForNew, mainCategory.categoryName) && !_.isEmpty(subCategories)) {
      subCategories = _.concat(subCategories, this.defaultNewCategory);
    }

    const subCategory = _.get(subCategories, '[0]', {});
    let tmp = CommonUtil.convertMobxObjToJsonObj(this.selectedCategory);
    tmp['mainCategory'] = mainCategory;
    tmp['subCategory'] = subCategory;

    this.selectedCategory = tmp;

    let categoryId = '';
    const mainCategoryId = mainCategory.id;
    if (_.isEmpty(currentCategory['subCategory'])) {
      categoryId = (mainCategoryId === -1 || mainCategoryId === 0) ? '' : mainCategoryId;
    } else {
      const subCategoryId = _.get(subCategory, 'id', 0);
      if (subCategoryId !== 0) {
        categoryId = subCategoryId;
      } else if (mainCategoryId !== 0) {
        categoryId = mainCategoryId;
      }
    }

    const { categoryType, categoryName } = mainCategory;

    if (categoryType === NEW) {
      this.updateCasinoFilter('categoryId', '');
      this.updateCasinoFilter('isNewGame', true);
    } else if (Utils.isSelectedAllCategory(categoryName)) {
      this.updateCasinoFilter('categoryId', '');
    } else {
      this.updateCasinoFilter('categoryId', categoryId);
    }
  }

  @action updateCasinoProviderFilter = (value) => {
    const providerId = _.get(value, 'providerId', '');
    const providerName = _.get(value, 'providerName', '');
    const gameType = _.get(value, 'gameType', '');

    this.updateCasinoFilter('providerName', providerName);
    this.updateCasinoFilter('provider', providerId === Constants.ALL_PROVIDER_ID ? '' : providerId)
    this.updateCasinoFilter('gameType', gameType);
    this.updateCasinoFilter('providerList', value);
  }

  @action updateCasinoFilter = (key, value) => {
    let tmp = CommonUtil.convertMobxObjToJsonObj(this.casinoFilter);
    tmp[key] = value;
    this.casinoFilter = tmp;
  }

  @action clearCasinoGames = () => {
    this.casinoGames = [];
  }

  @action updateCasinoGames = (value) => {
    if (_.isEmpty(value)) {
      const tmp = CommonUtil.convertMobxObjToJsonObj(this.casinoGames);
      this.casinoGames = CommonUtil.filterOutDuplicateData(tmp.concat(value));
      return;
    }

    if (this.casinoFilter.moreItems < value.length) {
      this.casinoFilter.moreItems = value.length;
    }
    if (!this.isLoadMoreGames) {
      this.casinoGames = value;
    } else {
      const tmp = CommonUtil.convertMobxObjToJsonObj(this.casinoGames);
      this.casinoGames = CommonUtil.filterOutDuplicateData(tmp.concat(value));
    }
  }

  @computed get getLimitSearchingChars() {
    return this.limitSearchingChars;
  }

  @computed get getSelectedMainCategoryId() {
    return _.get(this.selectedCategory, 'mainCategory.id');
  }

  @computed get getSelectedMainCategory() {
    return _.get(this.selectedCategory, 'mainCategory', this.defaultCategory[0].mainCategory);
  }

  @computed get getSelectedSubCategoryId() {
    return _.get(this.selectedCategory, 'subCategory.id', 0);
  }

  @computed get getSelectedProvider() {
    return this.casinoFilter.provider === '' ? defaultProviders[0] :
      {
        providerId: this.casinoFilter.provider,
        providerName: this.casinoFilter.providerName
      };
  }

  @computed get getCasinoSliderFilter() {
    return this.casinoSliderFilter;
  }

  @computed get isAvaiableWallets() {
    let totalBetCredit = 0;

    _.map(this.wallets, wallet => {
      totalBetCredit += wallet.betCredit;
    });

    return totalBetCredit > 0;
  }

  @observable playtechGamesById = {
    id: 0,
    data: {}
  };

  @action updatePlaytechGamesData(data) {
    this.playtechGamesData = data;
  }

  @action updatePlaytechGameById(data) {
    this.playtechGamesById = data
  }

  @action updateSelectedCasinoGame(data) {
    this.selectedCasinoGame = data;
  }
  
  @computed get getPlaytechGames() {
    return this.playtechGamesData;
  }

  @computed get getSelectedCasinoGame() {
    return this.selectedCasinoGame;
  }

  @computed get getPlaytechGameById() {
    return this.playtechGamesById;
  }

  @action updateSelectedProviders(data) {
    this.selectedProviders = data;
  }
  
  @action updateOtherCasinoProviders(data) {
    this.otherCasinoProviders = data;
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/CasinoStore.js